webpackJsonp([184662623972074],{

/***/ 280:
/***/ (function(module, exports) {

	module.exports = {"data":{"dataJson":{"companyInfo":{"name":"Contemporarium","slogan":"Health-minded contemporary dining"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-cb4bb46dcab852b3c30c.js